import PsychologyIcon from '@mui/icons-material/Psychology';
import * as React from 'react'

export default { PsychologyIcon, React }